import React from 'react';
import './PrintableForm.css';

const CatInformationForm: React.FC = () => {
  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="printable-form-container">
      <div className="no-print actions-bar">
        <button onClick={() => window.history.back()} className="back-btn">← Back to Forms</button>
        <button onClick={handlePrint} className="print-btn">🖨️ Print / Save as PDF</button>
      </div>

      <div className="printable-form">
        <div className="form-header">
          <h1>The Pet Nanny of Weston</h1>
          <p className="tagline">Licensed • Bonded • Insured</p>
          <p className="contact">thepetnannyofweston@gmail.com</p>
        </div>

        <h2 className="form-title">Cat Information Form</h2>

        <div className="form-section">
          <h3>Owner Information</h3>
          <div className="form-row">
            <div className="form-field half-width">
              <label>Owner Name:</label>
              <input type="text" />
            </div>
            <div className="form-field half-width">
              <label>Date:</label>
              <input type="date" />
            </div>
          </div>
        </div>

        <div className="form-section">
          <h3>Cat's Basic Information</h3>
          <div className="form-row">
            <div className="form-field half-width">
              <label>Cat's Name:</label>
              <input type="text" />
            </div>
            <div className="form-field half-width">
              <label>Nickname(s):</label>
              <input type="text" />
            </div>
          </div>
          <div className="form-row">
            <div className="form-field third-width">
              <label>Breed:</label>
              <input type="text" />
            </div>
            <div className="form-field third-width">
              <label>Age/Birthdate:</label>
              <input type="text" />
            </div>
            <div className="form-field third-width">
              <label>Weight:</label>
              <input type="text" />
            </div>
          </div>
          <div className="form-row">
            <div className="form-field half-width">
              <label>Color/Markings:</label>
              <input type="text" />
            </div>
            <div className="form-field half-width">
              <label>Gender:</label>
              <div style={{display: 'flex', gap: '1rem', marginTop: '0.25rem'}}>
                <label style={{fontWeight: 'normal', display: 'flex', alignItems: 'center'}}>
                  <input type="checkbox" /> Male
                </label>
                <label style={{fontWeight: 'normal', display: 'flex', alignItems: 'center'}}>
                  <input type="checkbox" /> Female
                </label>
                <label style={{fontWeight: 'normal', display: 'flex', alignItems: 'center'}}>
                  <input type="checkbox" /> Spayed/Neutered
                </label>
              </div>
            </div>
          </div>
          <div className="form-row">
            <div className="form-field full-width">
              <label>Microchip Number (if applicable):</label>
              <input type="text" />
            </div>
          </div>
          <div className="form-row">
            <div className="form-field full-width">
              <label>Indoor/Outdoor Status:</label>
              <div style={{display: 'flex', gap: '1rem', marginTop: '0.25rem'}}>
                <label style={{fontWeight: 'normal', display: 'flex', alignItems: 'center'}}>
                  <input type="checkbox" /> Indoor Only
                </label>
                <label style={{fontWeight: 'normal', display: 'flex', alignItems: 'center'}}>
                  <input type="checkbox" /> Outdoor Only
                </label>
                <label style={{fontWeight: 'normal', display: 'flex', alignItems: 'center'}}>
                  <input type="checkbox" /> Both
                </label>
              </div>
            </div>
          </div>
        </div>

        <div className="form-section">
          <h3>Feeding Information</h3>
          <div className="form-row">
            <div className="form-field full-width">
              <label>Brand and Type of Food:</label>
              <input type="text" />
            </div>
          </div>
          <div className="form-row">
            <div className="form-field third-width">
              <label>Amount Per Feeding:</label>
              <input type="text" />
            </div>
            <div className="form-field third-width">
              <label>Feeding Times:</label>
              <input type="text" placeholder="e.g., 7am, 6pm" />
            </div>
            <div className="form-field third-width">
              <label>Times Per Day:</label>
              <input type="text" />
            </div>
          </div>
          <div className="form-row">
            <div className="form-field full-width">
              <label>Treats Allowed? (please specify type and amount):</label>
              <input type="text" />
            </div>
          </div>
          <div className="form-row">
            <div className="form-field full-width">
              <label>Foods to AVOID / Allergies:</label>
              <textarea rows={2}></textarea>
            </div>
          </div>
          <div className="form-row">
            <div className="form-field full-width">
              <label>Special Feeding Instructions:</label>
              <textarea rows={2}></textarea>
            </div>
          </div>
        </div>

        <div className="form-section">
          <h3>Litter Box Information</h3>
          <div className="form-row">
            <div className="form-field half-width">
              <label>Type of Litter Preferred:</label>
              <input type="text" placeholder="e.g., clumping, crystal, clay" />
            </div>
            <div className="form-field half-width">
              <label>Litter Box Location at Home:</label>
              <input type="text" />
            </div>
          </div>
          <div className="form-row">
            <div className="form-field full-width">
              <label>How Often Should Litter Be Cleaned?</label>
              <input type="text" placeholder="e.g., daily, twice daily" />
            </div>
          </div>
          <div className="form-row">
            <div className="form-field full-width">
              <label>Any Litter Box Issues? (accidents, avoidance, etc.)</label>
              <textarea rows={2}></textarea>
            </div>
          </div>
        </div>

        <div className="form-section">
          <h3>Medical Information</h3>
          <div className="form-row">
            <div className="form-field full-width">
              <label>Current Medications (Name, Dosage, Frequency, Instructions):</label>
              <textarea rows={3}></textarea>
            </div>
          </div>
          <div className="form-row">
            <div className="form-field full-width">
              <label>Medical Conditions or Health Issues:</label>
              <textarea rows={3}></textarea>
            </div>
          </div>
          <div className="form-row">
            <div className="form-field full-width">
              <label>Allergies (medications, environmental, etc.):</label>
              <textarea rows={2}></textarea>
            </div>
          </div>
        </div>

        <div className="form-section">
          <h3>Behavior & Temperament</h3>
          <div className="form-row">
            <div className="form-field full-width">
              <label>Personality Description:</label>
              <textarea rows={2} placeholder="e.g., friendly, shy, playful, independent"></textarea>
            </div>
          </div>
          <div className="form-row">
            <div className="form-field half-width">
              <label>Gets Along With:</label>
              <div style={{marginTop: '0.5rem'}}>
                <div className="checkbox-group">
                  <input type="checkbox" id="other-cats" />
                  <label htmlFor="other-cats">Other Cats</label>
                </div>
                <div className="checkbox-group">
                  <input type="checkbox" id="dogs" />
                  <label htmlFor="dogs">Dogs</label>
                </div>
                <div className="checkbox-group">
                  <input type="checkbox" id="children" />
                  <label htmlFor="children">Children</label>
                </div>
                <div className="checkbox-group">
                  <input type="checkbox" id="strangers" />
                  <label htmlFor="strangers">Strangers</label>
                </div>
              </div>
            </div>
            <div className="form-field half-width">
              <label>Comfort Level:</label>
              <div style={{marginTop: '0.5rem'}}>
                <div className="checkbox-group">
                  <input type="checkbox" id="very-social" />
                  <label htmlFor="very-social">Very Social</label>
                </div>
                <div className="checkbox-group">
                  <input type="checkbox" id="moderately-social" />
                  <label htmlFor="moderately-social">Moderately Social</label>
                </div>
                <div className="checkbox-group">
                  <input type="checkbox" id="shy" />
                  <label htmlFor="shy">Shy/Skittish</label>
                </div>
                <div className="checkbox-group">
                  <input type="checkbox" id="hides" />
                  <label htmlFor="hides">Tends to Hide</label>
                </div>
              </div>
            </div>
          </div>
          <div className="form-row">
            <div className="form-field full-width">
              <label>Favorite Hiding Spots or Safe Spaces:</label>
              <input type="text" />
            </div>
          </div>
          <div className="form-row">
            <div className="form-field full-width">
              <label>Fears or Triggers (loud noises, sudden movements, etc.):</label>
              <textarea rows={2}></textarea>
            </div>
          </div>
          <div className="form-row">
            <div className="form-field full-width">
              <label>Any Scratching or Biting Behavior?</label>
              <textarea rows={2}></textarea>
            </div>
          </div>
        </div>

        <div className="form-section">
          <h3>Play & Enrichment</h3>
          <div className="form-row">
            <div className="form-field full-width">
              <label>Activity Level:</label>
              <div style={{display: 'flex', gap: '1rem', marginTop: '0.25rem'}}>
                <label style={{fontWeight: 'normal', display: 'flex', alignItems: 'center'}}>
                  <input type="checkbox" /> Low (Mostly sleeps)
                </label>
                <label style={{fontWeight: 'normal', display: 'flex', alignItems: 'center'}}>
                  <input type="checkbox" /> Moderate
                </label>
                <label style={{fontWeight: 'normal', display: 'flex', alignItems: 'center'}}>
                  <input type="checkbox" /> High (Very playful)
                </label>
              </div>
            </div>
          </div>
          <div className="form-row">
            <div className="form-field full-width">
              <label>Favorite Toys or Activities:</label>
              <input type="text" />
            </div>
          </div>
          <div className="form-row">
            <div className="form-field full-width">
              <label>Does Your Cat Like to be Brushed/Groomed?</label>
              <input type="text" />
            </div>
          </div>
        </div>

        <div className="form-section">
          <h3>Sleeping & Routine</h3>
          <div className="form-row">
            <div className="form-field full-width">
              <label>Where does your cat sleep at night?</label>
              <input type="text" />
            </div>
          </div>
          <div className="form-row">
            <div className="form-field full-width">
              <label>Typical Daily Routine/Schedule:</label>
              <textarea rows={3}></textarea>
            </div>
          </div>
        </div>

        <div className="form-section">
          <h3>Special Instructions or Notes</h3>
          <div className="form-row">
            <div className="form-field full-width">
              <label>Anything else we should know about your cat?</label>
              <textarea rows={4}></textarea>
            </div>
          </div>
        </div>

        <div className="form-section signature-section">
          <h3>Emergency Veterinary Authorization</h3>
          <div className="checkbox-group" style={{marginBottom: '1rem'}}>
            <input type="checkbox" id="vet-auth" />
            <label htmlFor="vet-auth">
              I authorize The Pet Nanny of Weston to seek emergency veterinary care for my cat if necessary. 
              I understand I am responsible for all veterinary costs.
            </label>
          </div>
          <div className="form-row">
            <div className="form-field half-width">
              <label>Owner Signature:</label>
              <div className="signature-line"></div>
            </div>
            <div className="form-field half-width">
              <label>Date:</label>
              <input type="date" />
            </div>
          </div>
        </div>

        <div className="form-footer">
          <p>Page 1 of 1</p>
          <p>The Pet Nanny of Weston • thepetnannyofweston@gmail.com</p>
        </div>
      </div>
    </div>
  );
};

export default CatInformationForm;
